import { Directive, HostBinding, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[formControlName],[formControl]',
    standalone: false
})
export class BootstrapValidationCssDirective {
  constructor(@Self() private cd: NgControl) {}

  @HostBinding('class.is-invalid')
  get isInvalid(): boolean {
    const control = this.cd.control;
    return control ? control.invalid && control.touched : false;
  }
  @HostBinding('class.is-invalid-untouched')
  get isInvalidUntouched(): boolean {
    const control = this.cd.control;
    return control ? control.invalid : false;
  }
}
